@if (!displayTotalCard) {
<div class="deduction-summary content-container table-comp">
  <div class="body p-0">
    <div>
      <mwp-table [tableColumns]="benefitColumns" [dataSource]="benefitMatTableData" [isModal]="true" />
    </div>
    <div class="summary-totals table-footer px-0">
      <div class="d-inline-flex justify-content-between w-100">
        <div class="summary-title w-100">
          <mwp-text-translate text="Total Pre & Post Tax Deductions" jsonKey="totalPre&PostTaxDeductions" />
        </div>
        <div class="summary-amount-width">
          {{ memberBenefitFlyout.totalPretaxAmount | currency }}
        </div>
        <div class="summary-amount-width ms-4 pe-2">
          {{ memberBenefitFlyout.totalPosttaxAmount | currency }}
        </div>
      </div>
    </div>
    <div class="summary-totals pt-3">
      <div class="message-card blue-fill d-inline-flex justify-content-between w-100">
        <div class="summary-title">
          <mwp-text-translate text="Total Deductions" jsonKey="totalDeductions" />
        </div>
        <div>
          {{ memberBenefitFlyout.totalDeductionAmount | currency }}
        </div>
      </div>
    </div>
    @if (totalCardMessageHTML) {
    <div [innerHTML]="totalCardMessageHTML | pipeSafeHTML" class="mb-3 px-3">
    </div>
    }
  </div>
</div>
}

@if (displayTotalCard) {
<div>
  <div class="content-container table-comp">
    <div class="title">
      <span class="me-1">{{ benefitTotal.frequencyDisplay }}</span>
      <mwp-text-translate text="Deductions" jsonKey="deductions" />
    </div>
    <div class="content">
      <table>
        <thead>
          <tr>
            <th class="ps-2">
              <mwp-text-translate text="Total Pre-Tax:" jsonKey="totalPreTax" />
            </th>
            <th class="text-center">
              <mwp-text-translate text="Total Post-Tax:" jsonKey="totalPostTax" />
            </th>
            <th class="pe-2 text-end">
              <mwp-text-translate text="Total Cost" jsonKey="totalCost" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="ps-2">
              {{ benefitTotal.totalPretax | currency }}
            </td>
            <td class="text-center">
              {{ benefitTotal.totalPosttax | currency }}
            </td>
            <td class="pe-2 text-end">
              {{ benefitTotal.totalCost | currency }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    @if (totalCardMessageHTML) {
    <div class="footer" [innerHTML]="totalCardMessageHTML | pipeSafeHTML" class="px-3">
    </div>
    }
  </div>
</div>
}